<template>
  <div>

    <div class=" pt-10 pl-10 pr-10">
      <div class="breadcrumbbar text-center">
        <Error class="pb-2" />
        <h1 id="noinfo">
          Trazabilidad de envio de productos
        </h1>

        <div class="col-12 pt-10">
            <validation-provider  name="folio">
              <v-text-field v-model="folio" v-on:keyup.enter="validateFolio()"
                suffix="Enter" class="br" label="ID ENVIO"
                placeholder="Identificador de envio" outlined >
              </v-text-field>
            </validation-provider>
          </div>
      </div>
    </div>

    <v-dialog
      v-model="dialog"

      hide-overlay

    >
      <v-card>
        <v-toolbar dark color="blue-fmedical">
          <v-toolbar-title class="pt-4">
            <p class="text-center">
              <i class="feather icon-paperclip mr-1"></i>
              {{ currentItem.branchOfficeOriginName }}
            </p>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="cleanModal()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <div class="row mt-8"></div>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
import { UtilFront } from "@/core";
import { OrderStockRequest, ShipmentsRequest, } from "@/core/request";
import AlertMessageComponent from "@/common/message/AlertMessageComponent";
import ButtonTableComponent from "@/common/table/ButtonTableComponent";
import { PICKING_ORDER_TRANSPARENCY } from "@/core/DataTableHeadersLocale";
import ChipTableCommonPagination from "@/common/table/ChipTableCommonPagination";
import Error from "@/other/common/Error";

export default {
  data() {
    return {
      expanded: [],
      folio: "",
      orderProductsHeaders: PICKING_ORDER_TRANSPARENCY(),
      dataList: [],
      item: {},
      dialog: false,
      loading: null,
      search: "",
      currentItem: {
        branchOfficeDestination: {},
        shipment: {},
        isView: false,
      },
      parametro1: null,
      pagesAtributes: {
        currentPage: 0,
        itemsPerPage: 15,
        search: "",
        sortBy: "",
        sortDesc: true,
        sortFilters: {},
      },
    };
  },
  components: {
    ButtonTableComponent,
    AlertMessageComponent,
    ChipTableCommonPagination,
    Error
  },
  created(){

    this.parametro1 = this.$route.query.envio; 

    console.log(  this.parametro1 );

    if ( this.parametro1 != '' ) {
      if ( this.parametro1 != undefined  )
        this.reloadComponent( this.parametro1 );
    } 



  },
  mounted() {},
  methods: {
    validateFolio(){
      console.log(this.folio);
      this.reloadComponent( this.folio );
    },
    cleanModal() {
      this.dataList = [];
      this.dialog = false;
    },
    async reloadComponent( item ) {
      this.currentItem = {};

      //Mustro la pantalla de cargando
      this.loading = UtilFront.getLoadding();
      //Abro el modal
      this.dialog = true;

      this.pagesAtributes.search = item;
      //this.currentItem = item;
      await ShipmentsRequest.listAllShipmentsWithTypeAndStatus(this.pagesAtributes)
        .then((response) => {
          let data = response.data;
          

          this.currentItem = data.content.find(shipment => shipment.idShipment === item);
          if ( this.currentItem == undefined )
          this.currentItem = {};
          
          console.log( this.currentItem  );
        })
        .catch((error) => {
          this.dialog = false;
        })
        .finally(() => {
          this.loading.hide();
      });
    

      if ( this.currentItem != null )
        await OrderStockRequest.ordersStockDetailWithRemission({
          idOrder: this.currentItem.orderId,
          status: [1, 3, 4, 6],
        })
          .then((response) => {
            let { status, data } = response;

            if (status == 200) {
              this.dataList = data;
            } else if (status == 202) {
              this.$refs.alertModal.reloadComponent("error", data);
            }
          })
          .catch((error) => {
            this.dialog = false;
          })
          .finally(() => {
            //this.orderProductsHeaders = PICKING_ORDER();
            //Elimino la pantalla de cargando
            this.loading.hide();
          });
    },

  },
};
</script>
